import * as React from 'react'
import { FC, useCallback } from 'react'

import { AddNoteFormModel } from '../typings'
import { useFormikContext } from 'formik'
import { ActionModalForm } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import { LocationMenu, NoteCode } from '@user/components/Notes/typings'
import { NoteFormFieldElements } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/NoteFormElements'

interface Props {
  externalLocationId?: string
  serviceOptions: LocationMenu[]
  noteCodes: NoteCode[]
}

export const AddNoteFormFieldsModalForm: FC<Props> = (props) => {
  const { serviceOptions, externalLocationId, noteCodes } = props

  const { errors, submitForm, touched, values, setFieldValue, isSubmitting } =
    useFormikContext<AddNoteFormModel>()

  const onSave = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <ActionModalForm
      disableSave={isSubmitting}
      onSave={onSave}
      primaryBtnLabel="Save"
    >
      <Stack width="100%">
        <NoteFormFieldElements
          serviceOptions={serviceOptions}
          noteCodes={noteCodes}
          externalLocationId={externalLocationId}
          noteFieldName="detail"
          noteFieldHelp={
            errors.detail && touched.detail
              ? errors.detail
              : `${values.detail.length.toLocaleString()}/5,000`
          }
          noteFieldError={errors.detail && touched.detail}
          toggleName="addNotesToPestPac"
          toggleValue={values.addNotesToPestPac}
          requiredOtherFields={Boolean(values.addNotesToPestPac)}
          serviceLocationFieldName="serviceLocation"
          serviceLocationHelp={
            errors.serviceLocation && touched.serviceLocation
              ? errors.serviceLocation
              : ''
          }
          serviceLocationError={
            errors.serviceLocation && touched.serviceLocation
          }
          noteCodeFieldName="code"
          noteCodeHelp={errors.code && touched.code ? errors.code : ''}
          noteCodeError={errors.code && touched.code}
          noteCode={values.code}
          setFieldValue={setFieldValue}
          serviceLocation={values.serviceLocation}
        />
      </Stack>
    </ActionModalForm>
  )
}

AddNoteFormFieldsModalForm.displayName = 'AddNoteFormFieldsModalForm'
